var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1641_45480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18.001C13.9706 18.001 18 13.9715 18 9.00098C18 4.03041 13.9706 0.000976562 9 0.000976562C4.02944 0.000976562 0 4.03041 0 9.00098C0 13.9715 4.02944 18.001 9 18.001Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5033 11.6031L12.902 9.00093H10.4061V7.31256C10.4061 6.60127 10.7542 5.90643 11.873 5.90643H13.0083V3.69155C13.0083 3.69155 11.9781 3.51562 10.9934 3.51562C8.93797 3.51562 7.59386 4.76102 7.59386 7.01766V9.00093H5.30811V11.6031H7.59386V17.8921C8.05202 17.9642 8.52158 18.0009 8.99999 18.0009C9.4784 18.0009 9.94796 17.963 10.4061 17.8921V11.6031H12.5033Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1641_45480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.bb62f5764e26c2123042e30264ae0669.svg";
export { ForwardRef as ReactComponent };